export default {
    periodicidade: [],
    periodicidadePlanos: [],
    periodicidades: {},
    ultimaAtualizacaoPeriodicidade: Date
}